import { ClienteGridState } from './types';

import {} from './apiThunk';

import { RootState } from 'src/app/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: ClienteGridState = {
  // Data
  selectedRow: null,

  // Actions
  actions: null,
};

const gridSlice = createSlice({
  name: 'clienteGrid',
  initialState,
  reducers: {
    setDataLoaded(state) {
      state.actions = {};
    },
    setRowSelection(state, action: PayloadAction<any>) {
      // Data
      state.selectedRow = action.payload;

      // Actions
      state.actions = {};
    },
    setRowUnselection(state) {
      // Data
      state.selectedRow = null;

      // Actions
      state.actions = {};
    },
  },
  extraReducers: (builder) => {},
});

// Actions
export const { setRowSelection, setRowUnselection, setDataLoaded } =
  gridSlice.actions;

// Selectors

// Data
export const selectSelectedRow = (state: RootState) =>
  state.cliente.grid.selectedRow;

export default gridSlice.reducer;
